import { useNavigate } from 'react-router-dom';

export default function SeoContentCards() {
  const navigate = useNavigate();

  const cards = [
    {
      image: 'https://readdy.ai/api/search-image?query=Closeup%20detail%20shot%20of%20a%20fashion%20item%20being%20inspected%20with%20a%20magnifying%20glass%20hovering%20over%20the%20stitching%20detail%2C%20a%20pair%20of%20white%20cotton%20gloves%20placed%20nearby%20on%20a%20dark%20walnut%20wood%20surface%2C%20professional%20quality%20control%20inspection%20scene%20with%20a%20bright%20desk%20lamp%20casting%20focused%20light%20on%20the%20textile%2C%20macro%20photography%20revealing%20intricate%20thread%20patterns%20and%20fabric%20weave%2C%20workshop%20atmosphere%20with%20tools%20and%20a%20notepad%20with%20handwritten%20notes%20in%20the%20softly%20blurred%20background&width=600&height=800&seq=seo-card-v2-qc-01&orientation=portrait',
      title: 'CSSBuy Sheet QC Guide',
      slug: '/cssbuy-qc-tutorial',
      description: 'Master the art of quality checking with our comprehensive guide to reading CSSBuy QC photos and avoiding bad batches.',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Curated%20selection%20of%20trendy%20fashion%20pieces%20including%20a%20pair%20of%20retro%20sneakers%20a%20graphic%20print%20hoodie%20and%20layered%20silver%20accessories%20arranged%20on%20a%20vibrant%20mustard%20yellow%20surface%2C%20late%20afternoon%20golden%20sunlight%20streaming%20diagonally%20across%20the%20items%20creating%20dramatic%20warm%20highlights%2C%20polaroid%20photos%20and%20washi%20tape%20mood%20board%20elements%20scattered%20around%20the%20edges%2C%20creative%20director%20desk%20aesthetic%20with%20bold%20color%20contrasts%20and%20artistic%20styling&width=600&height=800&seq=seo-card-v2-finds-02&orientation=portrait',
      title: 'Top CSSBuy Spreadsheet Finds',
      slug: '/cssbuy-best-finds-2026',
      description: 'Discover the most popular and trending items from the CSSBuy community this week — sneakers, streetwear, and luxury gems.',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Split%20composition%20product%20photography%20showing%20two%20similar%20premium%20leather%20goods%20placed%20side%20by%20side%20on%20a%20concrete%20surface%2C%20one%20slightly%20darker%20and%20more%20polished%20the%20other%20with%20a%20matte%20finish%2C%20small%20handwritten%20comparison%20labels%20with%20arrows%20pointing%20to%20key%20differences%2C%20diffused%20overcast%20daylight%20from%20a%20large%20window%20creating%20soft%20even%20illumination%2C%20analytical%20buyer%20guide%20photography%20style%20with%20clean%20modern%20aesthetic%20and%20objective%20visual%20comparison&width=600&height=800&seq=seo-card-v2-compare-03&orientation=portrait',
      title: 'Agent Comparison: CSSBuy vs Others',
      slug: '/cssbuy-spreadsheet-guide',
      description: 'A detailed breakdown comparing CSSBuy with other popular agents — pricing, shipping speed, QC quality, and user experience.',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3 whitespace-nowrap">
              SEO Guides
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
              CSSBuy Spreadsheet Resources
            </h2>
            <p className="text-sm text-foreground-500 max-w-md mx-auto">
              In-depth guides and curated lists to help you make smarter buying decisions with CSSBuy spreadsheets.
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {cards.map((card) => (
              <div key={card.title} className="group relative rounded-2xl overflow-hidden cursor-pointer">
                <div className="relative w-full aspect-[3/4] overflow-hidden rounded-2xl">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent"></div>

                  {/* Content overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-2 leading-snug">
                      {card.title}
                    </h3>
                    <p className="text-sm text-background-50/80 leading-relaxed mb-4 line-clamp-2">
                      {card.description}
                    </p>
                    <button
                      onClick={() => {
                        navigate(card.slug);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}
                      className="inline-flex items-center gap-1.5 text-sm font-medium text-background-50 border-b border-background-50/40 pb-0.5 hover:border-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Read Article
                      <i className="ri-arrow-right-line text-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA to article page */}
          <div className="text-center mt-10">
            <button
              onClick={() => {
                navigate('/cssbuy-shopping-guide');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              View All Shopping Guides
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}